﻿import React, {JSX, useMemo} from "react";
import {useControlId} from "../helpers/useControlId";
import {HtmlControlProps} from "./HtmlControlProps";

export type SwitchProps = Omit<HtmlControlProps<HTMLInputElement>, "value"> & {
	checked?: boolean;
}

export default function Switch(props: SwitchProps): JSX.Element {
	const {
		label,
		name,
		id,
		column,
		disabled,
		hidden,
		onChange,
		onBlur,
		ref,

		checked
	} = props;
	const controlId = useControlId(id);

	const klass = useMemo(() => "labelled-field switch--horizontal" + (column ? ` ${column}` : ""), [column]);

	if (hidden) {
		return <></>;
	}

	return (
		<div className={klass}>
			<div className="form__field form__field--switch">
				<input type="checkbox"
				       role="switch"
				       ref={ref}
				       id={controlId}
				       name={name}
				       onChange={onChange}
				       onBlur={onBlur}
				       value={"1"}
				       defaultChecked={checked}
				       tabIndex={disabled ? -1 : undefined}
				       readOnly={disabled}/>
				<label className="switch__label" htmlFor={controlId} data-off="" data-on="">
					<span className="label__text">{label}</span>
				</label>
			</div>
		</div>
	);
};
